import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import store from './state';
import App from './App';
import * as serviceWorker from './ServiceWorker';
import Hotjar from './components/Hotjar';
import Sentry from './components/SentryReport';
import GoogleAnalytics from './components/GoogleAnalytics';

const Application = () => (
  <Provider store={store}>
    <Hotjar />
    <Sentry />
    <GoogleAnalytics />
    <Router>
      <App />
    </Router>
  </Provider>
);
ReactDOM.render(<Application />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();